import React from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import styles from './WidgetCarousel.scss';

interface WidgetFeatureCarouselProps {
  children: React.ReactChild;
  currentSlideId: string;
  isSlidingBackward?: boolean;
  isAnimationDisabled?: boolean;
  dataHook?: string;
}

export const widgetCarouselEnterTimeout = parseInt(styles.widgetCarouselEnterTimeout, 10);
export const widgetCarouselLeaveTimeout = parseInt(styles.widgetCarouselLeaveTimeout, 10);

export const WidgetCarousel: React.FC<WidgetFeatureCarouselProps> = ({
  children,
  currentSlideId,
  isSlidingBackward = false,
  isAnimationDisabled = false,
  dataHook,
}) => {
  const enterClassName = isSlidingBackward ? styles.carouselSlideBackwardEnter : styles.carouselSlideEnter;
  const exitActiveClassName = isSlidingBackward
    ? styles.carouselSlideBackwardLeaveActive
    : styles.carouselSlideLeaveActive;

  return (
    <div className={styles.carousel} data-hook={dataHook}>
      <TransitionGroup enter={!isAnimationDisabled} exit={!isAnimationDisabled}>
        <CSSTransition
          key={currentSlideId}
          classNames={{
            enter: enterClassName,
            enterActive: styles.carouselSlideEnterActive,
            exit: styles.carouselSlideLeave,
            exitActive: exitActiveClassName,
          }}
          timeout={{ enter: widgetCarouselEnterTimeout, exit: widgetCarouselLeaveTimeout }}
        >
          <div className={styles.carouselSlide}>{children}</div>
        </CSSTransition>
      </TransitionGroup>
    </div>
  );
};
